<template>
  <form>
    <form class="form-wrapper">
      <h1>Add user to Question Bank Cohort</h1>
      <form class="add-user-to-cohort" @submit="handleSubmit">
        <label for="user-id">User IDs</label>
        <textarea
          id="user-id"
          v-model="userID"
          class="p-3 border"
          autofocus
          placeholder="Enter one or more user id or email (separated by comma or newline)"
          required
          type="text"
        />
        <div class="flex mt-3">
          <input
            id="add_user"
            v-model="addUser"
            type="radio"
            :value="true"
            style=" width: auto;margin: 0;"
          />
          <label for="add_user" class="ml-3" style="padding: 0;"
            >Add/Activate User</label
          >
        </div>
        <div class="flex mt-3">
          <input
            id="archive_user"
            v-model="addUser"
            type="radio"
            :value="false"
            style=" width: auto;margin: 0;"
          />
          <label style="padding: 0;" class="ml-3" for="archive_user"
            >Archive User</label
          >
        </div>
        <label for="cohort-id">Select cohort</label>

        <VueSelect
          placeholder="Select Cohort"
          label="name"
          :options="cohortList"
          :reduce="cohort => cohort.name"
          @change="handleChange"
        />
        <div class="row">
          <label for="select-group">Select Group(s) to unlock</label>
          <VueSelect
            id="select-group"
            v-model="selectedGroupsList"
            class="w-full"
            label="name"
            :options="groupsList"
            multiple
          />
        </div>
        <div class="relative">
          <button
            class="button-green link border p-3 px-12 rounded-full bg-green text-white font-bold"
          >
            Add/Activate/Unarchive or Archive User To Cohort
          </button>
          <div class="icon-container">
            <div
              v-if="addUserJobTriggered && !addUserStatus"
              title="Add to cohort in progress"
              class="loading-icon mx-4 my-6 hover:bg-transparent focus:bg-transparent"
            >
              <img src="../../assets/icons/svg/reload.svg" alt="" />
            </div>
            <div
              v-if="addUserJobTriggered && !addUserStatus"
              class="progress-val-container my-4"
            >
              <span v-if="addUserProgress">
                {{ addUserProgress }}% completed
              </span>
              <span v-else>
                0% completed
              </span>
            </div>
            <div v-if="addUserStatus" class="mx-4 my-6">
              <span
                v-if="addUserStatus === 'success'"
                title="Last add user job succeeded"
                class="text-green text-3xl"
                >✔</span
              >
              <span
                v-else
                title="Last add user job failed"
                class="text-red failed-indicator text-3xl"
                >✗</span
              >
            </div>
          </div>
        </div>
        <h2 class="tet-center">Result Section</h2>
        <div v-if="results" class="text-left mb-15">
          <div v-if="results.archived_list.length">
            <h3 class="text-left">Users archived from this cohort</h3>
            <ol>
              <li v-for="user in results.archived_list" :key="user">
                {{ user }}
              </li>
            </ol>
          </div>
          <div v-if="results.unarchived_list.length">
            <h3 class="text-left">
              Users activated (unarchived) back in this cohort
            </h3>
            <ol>
              <li v-for="user in results.unarchived_list" :key="user">
                {{ user }}
              </li>
            </ol>
          </div>
          <div v-if="results.cohort_added_list.length">
            <h3 class="text-left">Users added to cohort</h3>
            <ol>
              <li v-for="user in results.cohort_added_list" :key="user">
                {{ user }}
              </li>
            </ol>
          </div>
          <div v-if="results.not_found_list.length">
            <h3 class="text-left">Users not yet on our platform/cohort</h3>
            <ol>
              <li v-for="user in results.not_found_list" :key="user">
                {{ user }}
              </li>
            </ol>
          </div>
        </div>
      </form>
    </form>
  </form>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      userID: "",
      cohortID: "",
      cohortList: [],
      results: "",
      //   paymentUnlock: false,
      //   unlockFullPath: false,
      addUser: true,
      jobId: undefined,
      intervalId: undefined,
      addUserStatus: undefined,
      addUserProgress: undefined,
      addUserJobTriggered: false, // for UX purpose only
      groupsList: [],
      selectedGroupsList: [],
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}question_bank/cohorts?pagination=false`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.cohortList = res.data.items
    })
  },
  methods: {
    handleChange(option) {
      if (option) {
        this.cohortID = option.id
        this.selectedGroupsList = []
        this.groupsList = option.groups.filter(group => group.base_price) // add only groups with base price more than 0 i.e locked groups
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.addUserToCohort()
    },
    fetchAddUserStatus() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/question_bank/add_users_status/${this.cohortID}/${this.jobId}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          if (
            (res.data.status && res.data.status === "initiated") ||
            res.data.status === "inprogress"
          ) {
            this.addUserProgress = res.data.progress
            return
          }
          if (res.data.status && res.data.status === "successful") {
            this.addUserStatus = "success"
            clearInterval(this.intervalId)
            this.$noty.success(
              "Add users job was successful, please check result section for detailed info."
            )
            this.results = res.data.result
          } else if (res.data.status && res.data.status === "failed") {
            clearInterval(this.intervalId)
            this.addUserStatus = "failed"
            console.error(res)
            this.$noty.error(res.data.status)
          } else {
            clearInterval(this.intervalId)
            console.error(res)
          }
        })
        .catch(err => {
          clearInterval(this.intervalId)
          console.error(err)
        })
    },
    async addUserToCohort() {
      let cohortName = ""
      for (let idx = 0; idx < this.cohortList.length; idx++) {
        if (this.cohortList[idx].id === this.cohortID) {
          cohortName = this.cohortList[idx].name
          break
        }
      }
      const action = this.addUser ? "activate back or add" : "archive"
      const v = await this.$swal({
        text: `Please check cohort! Are you sure you want to ${action} these users in
        ${cohortName} with cohort ID: ${this.cohortID}?`,
        buttons: {
          cancel: true,
          confirm: {
            text: "Yes",
            value: true,
          },
        },
      })
      if (!v) {
        return
      }

      if (this.addUser) {
        const v2 = await this.$swal({
          text: `Please check cohort and user! Are you sure you want to unlock full path of these users in
  ${cohortName} with cohort ID: ${this.cohortID}?`,
          buttons: {
            cancel: true,
            confirm: {
              text: "Yes",
              value: true,
            },
          },
        })
        if (!v2) {
          return
        }
      }

      const payload = {
        users_list: this.userID,
        unlock_paid_groups: this.selectedGroupsList,
      }
      this.results = undefined
      this.axios({
        method: "post",
        url: `${
          siteConfig.siteURL
        }admin/question_bank/add_users_list_to_cohort/${
          this.cohortID
        }?archive_user_cohort=${+!this.addUser}`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          if (res.data.status) {
            this.jobId = res.data.uuid
            this.$noty.success(
              "Background job added, notification will be sent once succeeds"
            )
            this.addUserJobTriggered = true
            this.addUserStatus = undefined
            this.addUserProgress = 0
            this.intervalId = setInterval(() => {
              this.fetchAddUserStatus()
            }, 5000)
            //
          } else {
            this.$noty.error(
              `Something went wrong, server responed with ${res.data}`
            )
          }
        })
        .catch(err => {
          if (
            err.response.data.message &&
            err.response.data.message.includes("Cohort is being updated")
          ) {
            this.$swal({
              icon: "error",
              text: err.response.data.message,
            })
          } else {
            this.$noty.error(
              `Something went wrong, server responed with ${err}`
            )
          }
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
textarea,
textarea select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
  /* text-align: center; */
}
textarea {
  height: 150px;
}
label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
.payment-unlock-checkbox {
  display: inline;
  width: auto;
  margin-left: 10px;
}

.icon-container {
  position: absolute;
  top: -17px;
  right: -54px;
}

.loading-icon {
  width: 2rem;
  height: 2rem;
}

.loading-icon img {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  animation: spin 1.5s infinite linear;
}

button:disabled {
  background: grey;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

div.progress-val-container {
  position: absolute;
  top: 1rem;
  left: 59px;
  white-space: nowrap;
}
</style>
